import React from 'react';
type SectionProps = {
  id?: string;
  className?: string;
  children: React.ReactNode;
  labelledBy?: string;
};
export function Section({
  id,
  className = '',
  children,
  labelledBy
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`relative w-full ${className}`} data-id="element-360" data-mp="2vx16lmhni7ui">
      {children}
    </section>;
}
export function Container({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  // `relative z-10` is baked in so content always paints above a section's
  // decorative DoodleScatter layer (which sits at z-0), on every route.
  return <div className={`relative z-10 mx-auto w-full max-w-6xl px-5 sm:px-8 ${className}`} data-id="element-361" data-mp="3eulqef5k6g89">
      {children}
    </div>;
}
export function Eyebrow({
  children,
  tone = 'navy',
  className = ''
}: {
  children: React.ReactNode;
  tone?: 'navy' | 'light';
  className?: string;
}) {
  return <p className={`font-meta text-xs font-semibold uppercase tracking-[0.18em] ${tone === 'navy' ? 'text-brand-navy' : 'text-brand-blue'} ${className}`} data-id="element-362" data-mp="1gh2bpcx1o8c7">
      {children}
    </p>;
}